import { PathOptions } from "leaflet";

export const boundary_100km = (): PathOptions => ({
  color: "#808080",
  weight: 2,
  opacity: 1,
  dashArray: "8 12",
  fillColor: "transparent",
  fillOpacity: 0,
});
